import { Component } from '@ecs/Component';

export class ShieldDisplay implements Component {
  readonly type = 'ShieldDisplay';
  
  constructor(
    public showShield: boolean = false,
    public shieldOpacity: number = 0,
    public shieldRadius: number = 25,
    public shieldColor: string = '#6666ff',
    public pulseIntensity: number = 0
  ) {}
}